import { FC, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Edit } from 'lucide-react';
import { toast } from 'react-toastify';
import api from '@/api/api';

interface RenameFileButtonProps {
  fileId: string;
  currentFileName: string;
  onRename: () => Promise<void>;
  isDisabled: boolean;
}

const RenameFileButton: FC<RenameFileButtonProps> = ({ fileId, currentFileName, onRename, isDisabled }) => {
  const [renameDialogVisible, setRenameDialogVisible] = useState(false);
  const [renameFile, setRenameFile] = useState({ filename: '' });

  const renameFileAction = async () => {
    try {
      const response = await api.put(`rename/${fileId}`, { ...renameFile });
      if (response.status === 200 || response.status === 202) {
        toast.success('Hotovo. Soubor byl přejmenován.');
        setRenameDialogVisible(false);
        setRenameFile({ filename: '' });
        await onRename();
      }
    } catch (error: any) {
      if (error?.response?.data?.detail) {
        toast.error(`Error: ${error.response.data.detail}`);
      } else {
        toast.error(`Chyba při změně názvu souboru.`);
      }
    }
  };

  return (
    <>
      <Button
        icon={<Edit size={16} />}
        text={true}
        rounded={true}
        severity={'info'}
        tooltip={'Přejmenovat soubor'}
        tooltipOptions={{ position: 'right' }}
        onClick={() => setRenameDialogVisible(true)}
        disabled={isDisabled}
      />

      <Dialog
        draggable={false}
        style={{ width: '25rem' }}
        header="Přejmenovat soubor"
        visible={renameDialogVisible}
        onHide={() => setRenameDialogVisible(false)}
      >
        <div className="flex flex-col gap-4 mb-5">
          <div className="flex flex-col">
            <label htmlFor="filename">Název souboru</label>
            <InputText
              id="filename"
              value={renameFile.filename ? renameFile.filename : currentFileName}
              onChange={(e) => setRenameFile({ ...renameFile, filename: e.target.value })}
            />
          </div>
        </div>
        <div className={'flex items-center justify-between'}>
          <Button label="Zrušit" onClick={() => setRenameDialogVisible(false)} className={'btn-cancel'} />
          <Button label="Přejmenovat" onClick={renameFileAction} autoFocus={true} className={'btn-secondary'} />
        </div>
      </Dialog>
    </>
  );
};

export default RenameFileButton;
